import { render, staticRenderFns } from "./PalletTop.vue?vue&type=template&id=dea689a4&"
import script from "./PalletTop.vue?vue&type=script&lang=js&"
export * from "./PalletTop.vue?vue&type=script&lang=js&"
import style0 from "./PalletTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListTile,VListTileTitle,VMenu})
